module.exports = __webpack_public_path__ + "img/transaction_deposit.b78e72e0.svg";